import { LanguageActionType } from 'my-constants/action-types';

let defaultState = {
    lang_code: null,
    resources: {},
	user_info: {}
};

const LanguageReducer = (state = defaultState, action) => {
	switch(action.type){
		case LanguageActionType.ON_CHANGE_LANGUAGE:
			return {...state, resources: action.payload.listLang, lang_code: action.lang_code, user_info: action.payload.userInfo};
		default:
			return {...state};
	}
};

export default LanguageReducer;